import { PostSortRowsParams } from "ag-grid-community";
import {
    ScenarioMetadata,
    ScenarioOrigin,
    ScenarioStatus
} from "in_queue/types/scenarioType";
import { RowGroup } from "./base/rowGrouping";

const DONE_STATUSES: ReadonlyArray<ScenarioStatus> = [
    ScenarioStatus.RunSucceeded,
    ScenarioStatus.Archived,
    ScenarioStatus.RunFailed
];
const RUNNING_STATUSES: ReadonlyArray<ScenarioStatus> = [
    ScenarioStatus.Running,
    ScenarioStatus.RunRequested,
    ScenarioStatus.RunSubmitted
];

// Lower sorts first: completed, then running, then drafts.
const statusRank = (status: ScenarioStatus): number => {
    if (DONE_STATUSES.includes(status)) return 0;
    if (RUNNING_STATUSES.includes(status)) return 1;
    return 2;
};

/**
 * The table's default order, until the user sorts a column. Applies within
 * each section when the table is grouped, and to every row when it isn't.
 */
export const scenarioStatusPostSort = (
    params: PostSortRowsParams<ScenarioMetadata>
): void => {
    if (params.api.getColumnState().some((column) => column.sort)) {
        return;
    }
    params.nodes.sort(
        (a, b) =>
            (a.data ? statusRank(a.data.status) : 0) -
            (b.data ? statusRank(b.data.status) : 0)
    );
};

/**
 * A placeholder for the unexpected case where a scenario has no origin field.
 */
const UNKNOWN_SCENARIO_ORIGIN = "UNKNOWN_ORIGIN";

export const SCENARIO_ROW_GROUP: RowGroup<ScenarioMetadata> = {
    groups: [
        { key: ScenarioOrigin.BaseScenario, label: "Nira base scenarios" },
        {
            key: ScenarioOrigin.NiraPublished,
            label: "Nira published scenarios"
        },
        { key: ScenarioOrigin.Custom, label: "Custom scenarios" }
    ],
    getGroupKey: (scenario) => scenario.origin ?? UNKNOWN_SCENARIO_ORIGIN
};
